import {SET_WEB_CONFIG_DATA, SET_LOGIN_MESSAGE } from "./mutation-types";

const app = {
  // 全局状态
  state: {
    // WebConfig网站配置
    webConfigData: {},
    // 登录消息，用于控制登录弹框
    loginMessage: "",
  },
  // getters是对数据的包装，例如对数据进行拼接，或者过滤
  getters: {
    // 类似于计算属性
    // 增加的方法
  },
  // 如果我们需要更改store中的状态，一定要通过mutations来进行操作
  mutations: {
    // 设置WebConfig
    [SET_WEB_CONFIG_DATA](state, webConfigData) {
      state.webConfigData = webConfigData
    },

    // 设置消息
    [SET_LOGIN_MESSAGE] (state, loginMessage) {
      state.loginMessage = loginMessage
    },
  },

  // actions是我们定义的一些操作，正常情况下，我们很少会直接调用mutation方法来改变state
  actions: {

  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/app.js